import { LANGUAGE } from "./constants";
export default {
	lang: localStorage.getItem(LANGUAGE) || "en"
};
